import {
  Box,
  Button,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Image from "next/image";
import FeaturesSection from "@/components/sections/Home/FeaturesSection";
import HeroSection from "@/components/sections/Home/HeroSection";

const IntegrationSection = () => {
  const theme = useTheme();
  const isSmallMobile = useMediaQuery("(max-width: 599px)");
  return (
    <Box
      sx={{
        backgroundColor: isSmallMobile ? "transparent" : "#ecedef",
        width: "100%",
      }}>
      <Box
        sx={{
          px: { xs: 2, lg: 0 },
          pl: { xs: 2, lg: 5 },
          py: { xs: 6, lg: "100.5px" },
          maxWidth: { xs: "100%", md: "1420px" },
          mx: "auto",
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          alignItems: "stretch",
          justifyContent: "space-between",
          gap: { xs: 6, lg: 8 },
          minHeight: { lg: "500px" },
        }}>
        {/* Left Content */}
        <Box
          sx={{
            maxWidth: { xs: "100%", lg: "531px" },
            textAlign: { xs: "center", lg: "left" },
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}>
          <Typography
            sx={{
              fontFamily: "var(--font-poppins)",
              fontSize: { xs: "28px", lg: "36px" },
              fontWeight: 800,
              color: theme.palette.primary.main,
              lineHeight: 1.25,
              mb: 2,
            }}>
            Seamless integrations with marketplaces and carriers
          </Typography>

          {!isSmallMobile && (
            <Typography
              sx={{
                fontFamily: "RethinkSans, sans-serif",
                fontSize: { xs: "16px", lg: "20px" },
                color: "#212529",
                lineHeight: 1.5,
                maxWidth: "510px",
                mx: { xs: "auto", lg: 0 },
              }}>
              Easily connect your sales channels and start creating shipping
              labels with up to 90% instant discounts from top carriers like
              UPS, USPS, FedEx, DHL, and more. <br />
              <br />
              NestShipper syncs your orders automatically and gets you the best
              shipping rates no setup hassle.
            </Typography>
          )}

          <Stack
            direction="row"
            spacing={2}
            justifyContent={{ xs: "center", lg: "flex-start" }}
            alignItems="center"
            sx={{ mb: { xs: 4, lg: 5 }, mt: { xs: 3, lg: 5 } }}>
            <Image
              src="/images/EasyConnect.png"
              alt="Easy Connect"
              width={isSmallMobile ? 180 : 220}
              height={isSmallMobile ? 52 : 66}
            />

            <Image
              src="/images/FastSync.png"
              alt="Fast Sync"
              width={isSmallMobile ? 160 : 200}
              height={isSmallMobile ? 52 : 66}
            />
          </Stack>
        </Box>

        {/* Tornado Image */}
        <Box
          sx={{
            maxWidth: { xs: "300px", lg: "417.4px" },
            mx: "auto",
          }}>
          <Image
            src="/images/BrandTornado.png"
            alt="Brand Tornado"
            width={500}
            height={500}
            style={{
              width: "100%",
              height: "auto",
            }}
          />
        </Box>
        {isSmallMobile && (
          <Typography
            sx={{
              fontFamily: "RethinkSans, sans-serif",
              fontSize: { xs: "16px", lg: "20px" },
              color: "#212529",
              lineHeight: 1.5,
              maxWidth: "510px",
              mx: { xs: "auto", lg: 0 },
            }}>
            Easily connect your sales channels and start creating shipping
            labels with up to 90% instant discounts from top carriers like UPS,
            USPS, FedEx, DHL, and more. <br />
            <br />
            NestShipper syncs your orders automatically and gets you the best
            shipping rates no setup hassle.
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default IntegrationSection;
